import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const NaverCallbackPage: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // OAuth flow is no longer supported, redirect to login
    navigate('/login', {
      state: {
        error: '소셜 로그인 방식이 변경되었습니다. 직접 로그인을 해주세요.'
      }
    })
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <p className="text-gray-600">
          로그인 페이지로 이동하고 있습니다...
        </p>
      </div>
    </div>
  )
}
